import { create } from 'zustand';

// Boot state for the third-party widgets that initialise once per authenticated
// session (Intercom, NPS). Deliberately not persisted: a reload tears the
// widgets down, so this must start empty on every page load.
interface WidgetSessionState {
  // The user Intercom is currently booted as, not just "booted" — the hub
  // transition swaps users without ever clearing authtoken.
  intercomBootedUserId: string | null;
  // Same reasoning for NPS, keyed on user + company: the widget's init payload
  // carries both, and a hub transition changes both.
  npsInitializedFor: string | null;
  // Handle for the in-flight ContinuNPS script poll, so an identity change can
  // cancel a poll that would otherwise init with the previous identity.
  npsScriptPollId: ReturnType<typeof setInterval> | null;
  setIntercomBootedUserId: (userId: string | null) => void;
  setNpsInitializedFor: (identity: string | null) => void;
  setNpsScriptPollId: (pollId: ReturnType<typeof setInterval> | null) => void;
}

export const useWidgetSessionStore = create<WidgetSessionState>((set) => ({
  intercomBootedUserId: null,
  npsInitializedFor: null,
  npsScriptPollId: null,
  setIntercomBootedUserId: (userId) => set(() => ({ intercomBootedUserId: userId })),
  setNpsInitializedFor: (identity) => set(() => ({ npsInitializedFor: identity })),
  setNpsScriptPollId: (pollId) => set(() => ({ npsScriptPollId: pollId })),
}));
